import { lazy, Suspense, useState } from 'react'
import { Button } from '~/components-v2'
import { Blobby } from '~/components-v2/blobby/blobby'

const loadGame = () => import('~/components-v2/blob-static')

const BlobbyBreaker = lazy(() =>
  loadGame().then((m) => ({ default: m.BlobbyBreaker })),
)

const GameCover = () => {
  const [playing, setPlaying] = useState(false)

  return (
    <div className="not-found-arcade">
      {playing ? (
        <Suspense fallback={null}>
          <BlobbyBreaker autoFocus colorScheme="dark" />
        </Suspense>
      ) : (
        // Hovering or focusing the cover starts the download so play feels instant.
        <button
          type="button"
          className="not-found-arcade-cover"
          onClick={() => setPlaying(true)}
          onFocus={loadGame}
          onPointerEnter={loadGame}
        >
          <Blobby expression="excited" className="not-found-arcade-blobby" />
          <span className="caps-xs not-found-arcade-eyebrow">
            Can't find your page?
          </span>
          <span className="heading-l not-found-arcade-title">
            Break some blobs instead
          </span>
          <span className="body-m not-found-arcade-hint">
            Steer with your mouse or arrow keys. Clear the board to level up.
          </span>
          <span className="omni-button omni-button--primary">
            Play Blob Breaker
          </span>
        </button>
      )}
    </div>
  )
}

export const NotFound = ({
  title,
  message,
}: {
  title: string
  message: string
}) => (
  <section className="not-found">
    <header className="not-found-hero">
      <p className="caps-xs text-brand">404 · Page not found</p>
      <h1 className="heading-xxl">{title}</h1>
      <p className="body-l not-found-message">{message}</p>
      <div className="not-found-actions">
        <Button to="/">Take me home</Button>
        <Button to="/blog" variant="secondary">
          Read the blog
        </Button>
      </div>
    </header>
    <GameCover />
  </section>
)
